module.exports = __webpack_public_path__ + "static/img/Report.fb96119.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icon/Report.jpg
// module id = qq/I
// module chunks = 2